angular.module('aq.filters.transformers')
.filter('positive', function() {
    return function(input, field) {
        return _.filter(input, function(elem) {
            return elem[field] && elem[field] > 0;
        });
    }
});